/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { useAuth } from "context/AuthContext";

export function SidebarLinks({ routes, layout = "/admin" }) {
  const location = useLocation();
  const { role } = useAuth();

  // A stricter active check: highlights when you're exactly on the route,
  // or inside its nested segments if you want that behavior.
  const isActive = (routePath) => {
    // Normalize to absolute path
    const full = `${layout}/${routePath}`.replace(/\/+/g, "/");
    // Exact match or a nested path (e.g., /admin/services/123)
    return location.pathname === full || location.pathname.startsWith(full + "/");
  };

  // Only include visible routes for this sidebar, filtered by role
  const visibleRoutes = (routes || []).filter(
    (r) =>
      r.layout === layout &&
      !r.invisible &&
      Boolean(r.name) &&
      Boolean(r.path) &&
      (!r.roles || r.roles.includes(role))
  );

  return (
    <>
      {visibleRoutes.map((route) => {
        const active = isActive(route.path);

        return (
          <Link key={`${route.layout}-${route.path}`} to={`${route.layout}/${route.path}`}>
            <div className="relative mb-1.5 sm:mb-3 flex hover:cursor-pointer">
              <li className="my-[1px] flex cursor-pointer items-center px-3 py-2.5 sm:px-6 sm:py-3">
                <span
                  className={`flex-shrink-0 ${
                    active
                      ? "font-bold text-brand-500 dark:text-white"
                      : "font-medium text-gray-600"
                  }`}
                >
                  {route.icon ? route.icon : <DashIcon />}{" "}
                </span>
                <p
                  className={`leading-tight ml-2 sm:ml-4 flex text-sm sm:text-base ${
                    active
                      ? "font-bold text-navy-700 dark:text-white"
                      : "font-medium text-gray-600"
                  }`}
                >
                  {route.name}
                </p>
              </li>

              {active ? (
                <div
                  className="absolute right-0 top-px h-7 sm:h-9 w-0.5 sm:w-1 rounded-lg bg-brand-500 dark:bg-brand-400"
                />
              ) : null}
            </div>
          </Link>
        );
      })}
    </>
  );
}

export default SidebarLinks;
